import {
    GET_GST_INVOICE_INIT,
    GET_GST_INVOICE_SUCCESS,
    GET_GST_INVOICE_ERROR,
  } from "../constants/GstInvoiceConstants.js";
  
  const initialState = {
    data: [],
    loading: false,
    error: null,
    success: false,
    delete: false,
  };
  
  const gstinvoice = (state = initialState, action) => {
    switch (action.type) {
      case GET_GST_INVOICE_INIT:
        return { ...state, loading: true };
      case GET_GST_INVOICE_SUCCESS:
        return { ...state, success: true, data: action.data, loading: false };
      case GET_GST_INVOICE_ERROR:
        return { ...state, error: action.error, loading: false };
      default:
        return state;
    }
  };
  
  export default gstinvoice;
  